import { apiUrl } from "../../config/api";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import './Blog.css';
import './Blog.mobile.css';

const Blog = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);

  useEffect(() => {
    fetch(apiUrl("/api/blog/articles/"))
      .then((res) => {
        if (!res.ok) throw new Error("Erreur lors du chargement des articles");
        return res.json();
      })
      .then((data) => { setArticles(data); setLoading(false); })
      .catch((err)  => { setError(err.message); setLoading(false); });
  }, []);

  if (loading) {
    return (
      <div className="blog-loading">
        <span>CHARGEMENT</span>
        <span className="loading-dots">…</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="blog-error">
        <span className="error-label">ERREUR</span>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="blog">
      <header className="blog-header">
        <div className="blog-header-label" />
        <h1 className="blog-title">BLOG</h1>
        <div className="blog-count">
          {articles.length} ARTICLE{articles.length !== 1 ? "S" : ""}
        </div>
      </header>

      {articles.length === 0 && (
        <div className="blog-empty">AUCUN ARTICLE DISPONIBLE.</div>
      )}

      <div className="blog-grid">
        {articles.map((article, index) => (
          <article key={article.id} className="blog-card">
            <div className="blog-card-index">
              #{String(index + 1).padStart(2, "0")}
            </div>
            <h2 className="blog-card-title">{article.title}</h2>
            <div className="blog-card-meta">
              {new Date(article.created_at).toLocaleDateString("fr-FR", {
                day: "2-digit", month: "long", year: "numeric",
              })}
            </div>
            <p className="blog-card-excerpt">
              {article.content
                ? article.content.slice(0, 200) + "…"
                : "Contenu indisponible"}
            </p>
            <Link to={`/blog/${article.slug}`} className="blog-card-link">
              LIRE LA SUITE →
            </Link>
          </article>
        ))}
      </div>
    </div>
  );
};

export default Blog;